import { render, staticRenderFns } from "./configEnglishChat.vue?vue&type=template&id=239110d6&scoped=true&"
import script from "./configEnglishChat.vue?vue&type=script&lang=js&"
export * from "./configEnglishChat.vue?vue&type=script&lang=js&"
import style0 from "./configEnglishChat.vue?vue&type=style&index=0&id=239110d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239110d6",
  null
  
)

export default component.exports